import { useRouter } from 'next/router';

import EfCardList from '@elem/ui/ef-card-list';
import EfTitle from '@elem/ui/ef-title';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function PowerSolutions() {
    const { t } = useLang('fourinone.teaser');
    const { locale } = useRouter();

    const list = [
        {
            pc:
                locale === 'uk'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1725527755695/power_solution_uk_1.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1725527563531/power_solution_1.jpg',
            h5:
                locale === 'uk'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1725527755650/power_solution_1_h5_uk.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1725527563404/power_solution_1_h5.jpg',
            title: t('power_solutions_card_title_1'),
            description: (
                <span className="power-desc-box">
                    <span className="power-desc-item">{t('power_solutions_card_desc_1_1')}</span>
                    <span className="power-desc-item">{t('power_solutions_card_desc_1_2')}</span>
                </span>
            ),
        },
        {
            pc:
                locale === 'uk'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1724145598372/power_solution_uk_2.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1724145543846/power_solution_2.jpg',
            h5:
                locale === 'uk'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1724207246242/power_solution_2_h5_uk.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1724207022911/power_solution_2_h5.jpg',
            title: t('power_solutions_card_title_2'),
            description: (
                <span className="power-desc-box">
                    <span className="power-desc-item">{t('power_solutions_card_desc_2_1')}</span>
                    <span className="power-desc-item">{t('power_solutions_card_desc_2_2')}</span>
                </span>
            ),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724145544594/power_solution_3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724207052627/power_solution_3_h5.jpg',
            title: t('power_solutions_card_title_3'),
            description: (
                <span className="power-desc-flex-box">
                    <span className="power-desc-box">
                        <span className="power-desc-item">{t('power_solutions_card_desc_3_1')}</span>
                        <span className="power-desc-item">{t('power_solutions_card_desc_3_2')}</span>
                    </span>
                    <span className="power-desc-box">
                        <span className="power-desc-item">{t('power_solutions_card_desc_3_3')}</span>
                        <span className="power-desc-item">{t('power_solutions_card_desc_3_4')}</span>
                    </span>
                </span>
            ),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724145544469/power_solution_4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724207194022/power_solution_4_h5.jpg',
            title: t('power_solutions_card_title_4'),
            description: (
                <span className="power-desc-box">
                    <span className="power-desc-item">{t('power_solutions_card_desc_4_1')}</span>
                    <span className="power-desc-item">{t('power_solutions_card_desc_4_2')}</span>
                </span>
            ),
        },
    ];
    return (
        <div className={styles.PowerSolutions}>
            <EfTitle hasAnimation={false}>{t('power_solutions_title')}</EfTitle>
            <EfCardList list={list} isSwiper={false} />
        </div>
    );
}
